import { api } from "@/shared/libs/axiosClient";
import type {
  CollectionErrorsResponse,
  CollectionsErrorsDateRange,
} from "@/types/collection-types";

/**
 * 수집 오류 조회
 */
export async function fetchCollectionErrors(
  dateRange: CollectionsErrorsDateRange = "today"
): Promise<CollectionErrorsResponse> {
  return api.get<CollectionErrorsResponse>("/collection-errors", {
    params: { date_range: dateRange },
  });
}
